import { render, staticRenderFns } from "./KnowledgeTable.vue?vue&type=template&id=f963e71e&scoped=true"
import script from "./KnowledgeTable.vue?vue&type=script&lang=js"
export * from "./KnowledgeTable.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeTable.vue?vue&type=style&index=0&id=f963e71e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f963e71e",
  null
  
)

export default component.exports